import { Component, ElementRef, HostListener, ViewChild } from "@angular/core";
import { LoanDashboardService } from "./loan-dashboard.service";
import { Subscription, tap } from "rxjs";
import { UntilDestroy } from "@ngneat/until-destroy";
import { StoreService } from "src/app/shared/services/store.service";
import { Router } from "@angular/router";
import { SwiperService } from "src/app/shared/services/swiper.service";
import { fadeSlideInUp } from "src/app/shared/ui-animations";

@UntilDestroy({ arrayName: "subscriptions" })
@Component({
    selector: "web-loan-dashboard",
    templateUrl: "./loan-dashboard.component.html",
    styleUrls: ["./loan-dashboard.component.scss"],
    animations: [fadeSlideInUp],
})
export class LoanDashboardComponent {
    @ViewChild("bannerSwiper") bannerSwiper!: ElementRef<HTMLElement>;
    subscriptions: Subscription[] = [];
    infoCard: { [key: string]: any } = {};
    showCibil: boolean = false;
    isMobile = false;
    fcmToken: string | null = null;

    constructor(
        private router: Router,
        public loanDashboardService: LoanDashboardService,
        private storeService: StoreService,
        private swiperService: SwiperService
    ) {
        this.subscriptions.push(
            this.loanDashboardService.timeline$
                .pipe(
                    tap(async (res: any) => {
                        this.showCibil = !["BLACKLIST", "COOL_OFF"].includes(res.stage) ? true : false;
                        if (res?.cardInfo && Object.keys(res?.cardInfo?.infoCard || {}).length > 0) {
                            this.infoCard = res?.cardInfo;

                            setTimeout(() => {
                                this.loadBannerSwiper();
                            }, 100);
                        }

                        if (!res || res.length == 0) {
                            this.loanDashboardService.getDashboardDetails(true);
                        }
                    })
                )
                .subscribe()
        );
    }

    ngOnInit() {
        this.checkScreen();
    }

    @HostListener("window:resize")
    checkScreen() {
        this.isMobile = window.innerWidth <= 820;
    }

    loadBannerSwiper() {
        const totalSlides = this.infoCard?.["infoCard"]?.length || 0;
        const width = window.innerWidth;

        let maxVisible = 1;

        if (width >= 1500) maxVisible = 5;
        else if (width >= 1320) maxVisible = 4;
        else if (width >= 992) maxVisible = 3;
        else if (width >= 576) maxVisible = 2;
        else maxVisible = 1;

        this.swiperService.initSwiper(this.bannerSwiper.nativeElement, {
            loop: totalSlides > maxVisible,
            slidesPerView: 5,

            spaceBetween: 10,
            breakpoints: {
                0: {
                    slidesPerView: totalSlides > 1 ? 1.2 : 1,
                },
                576: {
                    slidesPerView: totalSlides > 2 ? 2.2 : 2,
                },
                992: {
                    slidesPerView: totalSlides > 3 ? 3.2 : 3,
                },
                1320: {
                    slidesPerView: totalSlides > 4 ? 4.2 : 4,
                },
                1500: {
                    slidesPerView: totalSlides > 5 ? 5.2 : 5,
                },
            },
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
        });
    }

    goToD2cDetails() {
        this.storeService.set({
            key: "fromD2cDetails",
            value: "DASHBOARD",
        });
        this.router.navigate(["/d2c"]);
    }

    goToReferAndEarn() {
        this.router.navigate(["/refer-and-earn"], { state: { fromWhere: "DASHBOARD" } });
    }
}
